import { motion } from "framer-motion";
import { MANIFESTO } from "@/data";

export const Manifesto = () => {
  return (
    <section id="process" data-testid="manifesto-section" className="relative bg-[var(--bg-0)] py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <span className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-[var(--blue)]">
          [ Notre process ]
        </span>
        <h2 className="mt-4 mb-16 font-display font-bold uppercase tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-none">
          Trois principes,
          <br />
          zéro compromis
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-md overflow-hidden">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.n}
              data-testid={`manifesto-chapter-${m.n}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="relative bg-[var(--bg-1)] p-8 sm:p-10 min-h-[300px] flex flex-col justify-between overflow-hidden"
            >
              <span className="pointer-events-none absolute -top-6 -right-2 font-display font-extrabold text-[9rem] leading-none text-white/[0.04] select-none">
                {m.n}
              </span>
              <span className="font-mono2 text-xs tracking-[0.2em] text-[var(--blue)] relative">{m.n}</span>
              <div className="relative mt-auto">
                <h3 className="font-display font-semibold text-2xl mb-4">{m.title}</h3>
                <p className="text-[var(--txt-1)] text-sm leading-relaxed">{m.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
